import React, {
  useState,
  isValidElement,
  cloneElement,
  useEffect
} from 'react';
import classNames from 'classnames';
import { omit } from 'lodash';
import debounce from 'lodash/debounce';

let defaultIndicator = null;
function renderIndicator(prefixCls, props) {
  const { indicator } = props;
  const cirClassName = `${prefixCls}-cir`;
  if (indicator === null) {
    return null;
  }
  if (isValidElement(indicator)) {
    return cloneElement(indicator, {
      className: classNames(indicator.props.className, cirClassName)
    });
  }
  if (isValidElement(defaultIndicator)) {
    return cloneElement(defaultIndicator, {
      className: classNames(defaultIndicator.props.className, cirClassName)
    });
  }
  return (
    <span className={classNames(cirClassName, `${prefixCls}-cir-spin`)}>
      <span className={`${prefixCls}-line-mask`}>
        <span className={`${prefixCls}-line`}></span>
      </span>
    </span>
  );
}

let originalUpdateSpinning = null;

export default props => {
  const {
    prefixCls = 'hfish-spin',
    className,
    size = 'default',
    tip,
    wrapperClassName,
    style,
    spinning: spinningProp,
    delay,
    ...restProps
  } = props;
  const shouldBeDelay = shouldDelay(spinningProp, delay);
  // spinning属性为true，且不延迟执行
  const [spinning, setSpinning] = useState(spinningProp && !shouldBeDelay);
  let updateSpinning = () => {
    if (spinningProp !== spinning) {
      setSpinning(spinningProp);
    }
  };

  useEffect(() => {
    originalUpdateSpinning = updateSpinning;
  }, []);

  useEffect(() => {
    deboucifyUpdateSpinning();
    updateSpinning();
    return () => {
      cancelExistingSpinning();
    };
  }, [delay, spinningProp]);

  // 延迟加载loading
  function deboucifyUpdateSpinning() {
    if (delay) {
      cancelExistingSpinning();
      updateSpinning = debounce(originalUpdateSpinning, delay);
    }
  }

  // 取消已存在的延迟loading
  function cancelExistingSpinning() {
    if (updateSpinning && updateSpinning.cancel) {
      updateSpinning.cancel();
    }
  }
  // 内嵌式loading
  function isNestedPattern() {
    return !!(props && props.children !== undefined);
  }

  // 可以被延迟执行
  function shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !isNaN(Number(delay));
  }
  const spinClassName = classNames(
    prefixCls,
    {
      [`${prefixCls}-sm`]: size === 'small',
      [`${prefixCls}-lg`]: size === 'large',
      [`${prefixCls}-spinning`]: spinning,
      [`${prefixCls}-show-text`]: !!tip
    },
    className
  );

  const divProps = omit(restProps, ['spinning', 'delay', 'indicator']);

  const spinElement = (
    <div {...divProps} style={style} className={spinClassName}>
      {renderIndicator(prefixCls, props)}
      {tip ? <div className={`${prefixCls}-text`}>{tip}</div> : null}
    </div>
  );

  if (isNestedPattern()) {
    const containerClassName = classNames(`${prefixCls}-container`, {
      [`${prefixCls}-blur`]: spinning
    });
    return (
      <div
        {...divProps}
        className={classNames(`${prefixCls}-nested-loading`, wrapperClassName)}
      >
        {spinning && <div key="loading">{spinElement}</div>}
        <div className={containerClassName} key="container">
          {props.children}
        </div>
      </div>
    );
  }
  return spinElement;
};
